import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid';

import { Policy } from 'common';
import {
  SLProducerOfRecordLicenseAddress,
  SLProducerOfRecordLicenseNum,
  SLProducerOfRecordLicensePhone,
  SLProducerOfRecordLicenseState,
  SLProducerOfRecordNameCol,
  agencyAddressCol,
  agencyNameCol,
  agentEmailCol,
  agentPhoneCol,
  cancelEffDateCol,
  cancelReasonCol,
  createdCol,
  currencyCol,
  effectiveDateCol,
  expirationDateCol,
  feesSumCol,
  homeStateCol,
  idCol,
  inStatePremiumCol,
  issuingCarrierCol,
  locationAddresses,
  locationsCount,
  mailingAddress1Col,
  mailingAddress2Col,
  mailingAddressCol,
  mailingCityCol,
  mailingPostalCol,
  mailingStateCol,
  namedInsuredDisplayNameCol,
  namedInsuredEmailCol,
  namedInsuredFirstNameCol,
  namedInsuredLastNameCol,
  namedInsuredPhoneCol,
  nestedAgencyOrgIdCol,
  nestedAgentNameCol,
  nestedAgentUserIdCol,
  outStatePremiumCol,
  productCol,
  taxesSumCol,
  termDaysCol,
  termPremiumCol,
  termPremiumWithCancelsCol,
  updatedCol,
  userIdCol,
} from './gridColumns';

export const policyCols: GridColDef<Policy>[] = [
  productCol,
  // locationAddresses,
  namedInsuredDisplayNameCol,
  { ...namedInsuredFirstNameCol, sortable: false, filterable: false },
  { ...namedInsuredLastNameCol, sortable: false, filterable: false },
  namedInsuredEmailCol,
  namedInsuredPhoneCol,
  {
    ...currencyCol,
    field: 'price',
    headerName: 'Price',
    sortable: true,
    filterable: true,
  },
  termPremiumCol,
  termPremiumWithCancelsCol,
  inStatePremiumCol,
  outStatePremiumCol,
  taxesSumCol,
  feesSumCol,
  termDaysCol,
  locationAddresses,
  locationsCount,
  effectiveDateCol,
  expirationDateCol,
  cancelEffDateCol,
  cancelReasonCol,
  homeStateCol,
  nestedAgentNameCol,
  agentEmailCol,
  agentPhoneCol,
  agencyNameCol,
  agencyAddressCol,
  issuingCarrierCol,
  nestedAgentUserIdCol,
  nestedAgencyOrgIdCol,
  userIdCol,
  {
    ...idCol,
    headerName: 'Policy ID',
  },
  mailingAddressCol,
  mailingAddress1Col,
  mailingAddress2Col,
  mailingCityCol,
  mailingStateCol,
  mailingPostalCol,
  SLProducerOfRecordNameCol,
  SLProducerOfRecordLicenseNum,
  SLProducerOfRecordLicenseState,
  SLProducerOfRecordLicensePhone,
  SLProducerOfRecordLicenseAddress,
  createdCol,
  updatedCol,
];

export const POLICY_COLUMN_VISIBILITY: GridColumnVisibilityModel = {
  product: false,
  paymentStatus: false,
  'namedInsured.firstName': false,
  'namedInsured.lastName': false,
  'namedInsured.email': false,
  'namedInsured.phone': false,
  price: false,
  termPremiumWithCancels: false,
  taxes: false,
  fees: false,
  inStatePremium: false,
  outStatePremium: false,
  locationsCount: false,
  cancelEffDate: false,
  cancelReason: false,
  termDays: false,
  homeState: false,
  'mailingAddress.addressLine1': false,
  'mailingAddress.addressLine2': false,
  'mailingAddress.city': false,
  'mailingAddress.state': false,
  'mailingAddress.postal': false,
  'mailingAddress.countyName': false,
  'mailingAddress.countyFIPS': false,
  'agent.email': false,
  'agent.phone': false,
  'agent.userId': false,
  'agency.address': false,
  annualPremium: false,
  'SLProducerOfRecord.licenseState': false,
  'SLProducerOfRecord.phone': false,
  'SLProducerOfRecord.address': false,
  'metadata.created': false,
  'metadata.updated': false,
};

// OPTION 1: "disableExport" property in the column definition
// OPTION 2: provide "fields" property to the csvOptions prop

// export const policyCSVExportCols = [
//   'id',
//   productCol.field,
//   namedInsuredFirstNameCol.field,
//   namedInsuredLastNameCol.field,
//   namedInsuredEmailCol.field,
//   namedInsuredPhoneCol.field,
//   'price',
//   locationsCount.field,
//   effectiveDateCol.field,
//   expirationDateCol.field,
//   homeStateCol.field,
//   nestedAgentNameCol.field,
//   agentEmailCol.field,
//   agencyNameCol.field,
//   agencyAddressCol.field,
//   issuingCarrierCol.field,
//   nestedAgentUserIdCol.field,
//   nestedAgencyOrgIdCol.field,
//   userIdCol.field,
//   SLProducerOfRecordNameCol.field,
//   SLProducerOfRecordLicenseNum.field,
//   SLProducerOfRecordLicenseState.field,
//   SLProducerOfRecordLicensePhone.field,
//   SLProducerOfRecordLicenseAddress.field,
//   // createdCol.field,
//   // updatedCol.field,
// ];
